import { environment } from "@/services";

export const getAppPath = () => {
	const { basePath } = environment();
	return basePath.includes("-pre") ? process.env.VUE_APP_ROUTE_PRE : process.env.VUE_APP_ROUTE;
};
